// extracted by mini-css-extract-plugin
export default {"root":"Desktop_root__kIGpQ"};